import { FormattedMessage } from 'components/shared/Intl';
import { FC, ReactNode } from 'react';
import { Modal, ModalBody, ModalFooter, ModalHeader, ModalTitle } from 'react-bootstrap';

export interface IrreversibleConfirmModalProps {
  onConfirm: (modalApi: any) => void;
  onClosed?: () => void;
  title?: ReactNode | string;
  description?: ReactNode | string;
  proceedMessage?: ReactNode | string;
  isOpen: boolean;
}

export const IrreversibleConfirmModal: FC<IrreversibleConfirmModalProps> = ({
  onConfirm,
  onClosed,
  isOpen,
  title,
  description,
}) => (
  <Modal
    centered
    backdrop="static"
    data-e2e="modal"
    contentClassName="border border-danger"
    className="confirm-modal-component"
    show={isOpen}
    role="dialog"
    aria-modal="true"
    aria-labelledby="irreversible-confirm-modal-title"
    aria-describedby="irreversible-confirm-modal-body"
  >
    <ModalHeader>
      <ModalTitle id="irreversible-confirm-modal-title" as="h3" className="text-danger">
        {title}
      </ModalTitle>
    </ModalHeader>
    <ModalBody id="irreversible-confirm-modal-body" data-e2e="modal-body">
      {description}
    </ModalBody>
    <ModalFooter>
      <button
        type="button"
        className="btn btn-lg btn-link"
        data-dismiss="modal"
        data-e2e="modal-cancel-button"
        onClick={onClosed}
      >
        <FormattedMessage id="form.Cancel" />
      </button>
      <button type="button" className="btn btn-lg btn-danger" data-e2e="modal-ok-button" onClick={onConfirm}>
        <FormattedMessage id="form.Confirm" />
      </button>
    </ModalFooter>
  </Modal>
);
